export default __webpack_public_path__ + "static/media/more.6cb2311f.svg";